export function scrollWithOffset(el, offset) {
  if (!el) return;
  
  // Find the ScrollArea viewport element
  const scrollAreaViewport = document.querySelector('[data-radix-scroll-area-viewport]');
  const scrollTarget = scrollAreaViewport || window;
  
  const elementPosition = el.offsetTop - offset;
  
  if (scrollAreaViewport) {
    // If using ScrollArea, use scrollTo on the viewport element
    scrollAreaViewport.scrollTo({
      top: elementPosition,
      behavior: "smooth",
    });
  } else {
    // Fallback to window scroll
    window.scroll({
      top: elementPosition,
      left: 0,
      behavior: "smooth",
    });
  }
}
